// extracted by mini-css-extract-plugin
export default {"employee-container":"CategoryCode_employee-container__3Y6+7"};